module.exports = __webpack_public_path__ + "static/media/mark-3-2000.751d3b90.jpg";